import styled, { css, keyframes } from 'styled-components';
import { media } from '@simplywallst/ui-core';
import type { TransitionStatus } from 'react-transition-group/Transition';
export const Dimmer = styled('div')`
  @media (min-width: 1024px) and (max-width: 1439px) {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 1;
    background-color: ${(props) => props.theme.color.blackRGBA(0.5)};
  }
`;

interface ContainerProps {
  left?: string;
}

export const Container = styled('div').attrs<ContainerProps>((props) => {
  return {
    style: {
      left: props.left,
    },
  };
})<ContainerProps>`
  position: fixed;
  top: 76px;
  right: 4px;
  width: 377px;
  height: calc(100vh - 88px);
  overflow: hidden;
  color: ${(props) => props.theme.color.lightGray};
  @media (min-width: 1024px) and (max-width: 1439px) {
    right: 0;
    top: ${(props) => props.theme.x8spacePx}px;
    z-index: 2;
    height: calc(100vh - ${(props) => props.theme.x8spacePx}px);
    width: 377px;
  }
  ${media.mdDown`
    height: calc(100vh);
    width: 100%;
    left: 0;
    top: 0;
    z-index: 9999; /** over 9000 */
  `}
`;

const menuEntering = keyframes`
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0%);
    opacity: 1;
  }
`;

const menuExiting = keyframes`
  0% {
    transform: translateX(0%);
    opacity: 1;
  }
  100% {
    transform: translateX(100%);
    opacity: 0;
  }
`;

const exited = keyframes`
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(100%);
  }
`;

interface Props {
  status: TransitionStatus;
  timeout: number;
}
export const TransformerContainer = styled('div')<Props>`
  ${(props) => {
    return css`
      position: relative;
      height: 100%;
      background-color: ${props.theme.color.noir};
      padding: ${props.theme.x2spacePx}px;
      border-radius: 8px;
      @media (min-width: 1024px) and (max-width: 1439px) {
        border-radius: 0px;
      }
      animation: ${() => {
          switch (props.status) {
            case 'entered':
            case 'entering':
              return menuEntering;
            case 'exited':
              return exited;
            case 'exiting':
              return menuExiting;
          }
        }}
        ${props.timeout}ms cubic-bezier(0.83, 0, 0.17, 1);
    `;
  }}
`;
